var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"page-login-header",domProps:{"textContent":_vm._s(_vm.$tf(_vm.message))}})}
var staticRenderFns = []

export { render, staticRenderFns }